import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translatEN from "./locales/en.json";
import translatES from "./locales/es.json";
import translatFR from "./locales/fr.json";
import translatIT from "./locales/it.json";
import translatPT from "./locales/pt.json";

const resources = {
	en: {
		translation: translatEN,
	},
	es: {
		translation: translatES,
	},
	fr: {
		translation: translatFR,
	},
	it: {
		translation: translatIT,
	},
	pt: {
		translation: translatPT,
	},
};

const usrSettingsData = localStorage.getItem("user.settings");
const usrLang = usrSettingsData ? JSON.parse(usrSettingsData).lang : "en";

i18n.use(LanguageDetector).use(initReactI18next).init({
	debug: true,
	resources,
	lng: usrLang,
	fallbackLng: "en",
});

// Keep <html lang> in sync with the active language so the browser's
// language detection heuristic doesn't auto-translate the page (paired
// with the `notranslate` meta tag and translate="no" attribute on <body>).
// Without this, Chrome on Android mis-detects the page language and
// translates fishing terms incorrectly (e.g. "bridas" → "novias").
function syncHtmlLang(lang: string) {
	if (typeof document !== "undefined" && document.documentElement) {
		document.documentElement.setAttribute("lang", lang);
	}
}
syncHtmlLang(usrLang);
i18n.on("languageChanged", syncHtmlLang);

export default i18n;
